import { ossHost } from '@/api/config/host'

export default {
    data() {
        return {
            ossHost: ossHost,
        }
    }
}